export default __webpack_public_path__ + "static/Artist-56c44cb2ad83b99397c128fe357cf421.png";